import { t } from 'i18next';
import { useState } from 'react';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import {
  HOOD_CLEANING_SERVICES,
  PAYMENT_TYPES,
} from '../../../config/constants';
import { inputFormatNumberMoney } from '../../../utils/numberFormatter';
import ButtonsManifestCarousel from '../../molecules/ButtonsManifestCarousel';

type HoodCleaningFormProps = {
  control: Control<any, any>;
  setPaymentType: any;
  paymentType: any;
  errors: any;
  setService: any;
  service: any;
};

export const HoodCleaningForm = ({
  control,
  setPaymentType,
  paymentType,
  errors,
  setService,
  service,
}: HoodCleaningFormProps) => {
  const [displayValueMoney, setDisplayValueMoney] = useState<string>('');
  return (
    <>
      <p className="text-sm text-ReyesBlack">{t('manifest.paymentT')}</p>
      <Controller
        name="paymentType"
        control={control}
        defaultValue=""
        rules={{ required: `${t('manifest.dropdownError')}` }} // Add this line
        render={({ field }) => (
          <ButtonsManifestCarousel
            field={field}
            options={PAYMENT_TYPES}
            setState={setPaymentType}
            state={paymentType}
          ></ButtonsManifestCarousel>
        )}
      />
      {errors.paymentType && (
        <span className="text-red-500">{errors.paymentType.message}</span>
      )}{' '}
      <p className="text-sm text-ReyesBlack">{t('manifest.service')}</p>
      <Controller
        name="service"
        control={control}
        defaultValue=""
        rules={{ required: `${t('manifest.dropdownError')}` }}
        render={({ field }) => (
          <ButtonsManifestCarousel
            field={field}
            options={HOOD_CLEANING_SERVICES}
            setState={setService}
            state={service}
            multi={true}
          ></ButtonsManifestCarousel>
        )}
      />
      {errors.service && (
        <span className="text-red-500">{errors.service.message}</span>
      )}
      <span>
        <p className="text-sm text-ReyesBlack">{t('manifest.price')}</p>
        <Controller
          name="pricePaid"
          control={control}
          rules={{
            required: `${t('manifest.error2')}`,
            pattern: /^[0-9]*$/,
            maxLength: 10,
          }}
          render={({ field }) => (
            <>
              <input
                type="number"
                id="pricePaid"
                {...field}
                style={{ display: 'none' }}
              />
              <input
                className="w-full border-b-2 border-ReyesGreyLight bg-transparent text-sm text-ReyesGrey focus:outline-none"
                type="text"
                id="pricePaidDisplay"
                value={displayValueMoney}
                maxLength={10}
                onChange={(e) => {
                  const stringValue = e.target.value.replace(/[$,]/g, '');
                  if (!Number.isNaN(Number(stringValue))) {
                    const numberValue = Number(stringValue);
                    field.onChange(numberValue);
                    setDisplayValueMoney(inputFormatNumberMoney(numberValue));
                  }
                }}
                style={{
                  appearance: 'none',
                  MozAppearance: 'textfield',
                }}
              />
            </>
          )}
        />
        {errors.pricePaid && (
          <>
            <br />
            <span className="text-red-500">{errors.pricePaid.message}</span>
          </>
        )}
      </span>
    </>
  );
};
